var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import AonPannel from "../../components/core/AonPannel";
import { UuiFlexlayout, UuiSpinner } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { createColumnHelper } from "@tanstack/react-table";
import { getDDMMYYYY } from "../../constants/utilities";
import { getmarketGuideStatus } from "../../api/marketData/getMarketGuideStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useClientPageStore, useErrorStore } from "../../store";
import { useNavigate } from "react-router-dom";
import "./MarketDetails.scss";
import { isInternaluser } from "../../api/auth/okta";
import { helpDocGuid } from "../../constants/helpDocGuids";
export var MarketGuideStatusPan = function (props) {
    var _a = useState({
        column_one: [],
        column_two: [],
        column_three: [],
        all_column: []
    }), MarketGuideStatus = _a[0], setMarketGuideStatus = _a[1];
    var _b = useState(false), MarketGuideStatusLoader = _b[0], setMarketGuideStatusLoader = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var id = props.id;
    var errorStore = useErrorStore();
    var clientStore = useClientPageStore();
    var navigation = useNavigate();
    useEffect(function () {
        fetchMarketGuideStatusData();
    }, []);
    var DownloadSubregionsPdf = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientStore.handlePdfDownload(helpDocGuid.subRegions)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchMarketGuideStatusData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var marketSpecificDataRes, c_one, c_two, c_three, all_c, item_1, allKeys, _loop_1, _i, allKeys_1, keys, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(id && isInternaluser())) return [3 /*break*/, 4];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    setMarketGuideStatusLoader(true);
                    return [4 /*yield*/, getmarketGuideStatus({ MarketId: Number(id) })];
                case 2:
                    marketSpecificDataRes = _e.sent();
                    c_one = [];
                    c_two = [];
                    c_three = [];
                    all_c = [];
                    item_1 = marketSpecificDataRes.data.fields;
                    if ((_a = marketSpecificDataRes === null || marketSpecificDataRes === void 0 ? void 0 : marketSpecificDataRes.data) === null || _a === void 0 ? void 0 : _a.applicableToMarketFlag) {
                        allKeys = Object.keys(item_1);
                        _loop_1 = function (keys) {
                            var itemValue = item_1[keys];
                            if (itemValue && typeof itemValue === 'object' && (itemValue).applicableToMarketFlag) {
                                if (keys === "MarketGuideStatus") {
                                    c_one.push({
                                        name: "Status",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "AdvisoryFlag") {
                                    var isActive = !!((_b = item_1.AdvisoryDocGuid) === null || _b === void 0 ? void 0 : _b.value);
                                    var DownLoadPDF_1 = function (value) { return __awaiter(void 0, void 0, void 0, function () {
                                        var error_3;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, clientStore.handlePdfDownload(value)];
                                                case 1:
                                                    _a.sent();
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    error_3 = _a.sent();
                                                    errorStore.showError({ message: "Error", code: "500" });
                                                    navigation('/error');
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    c_two.push({
                                        name: "Market Security Brief",
                                        value: "",
                                        element: React.createElement(React.Fragment, null,
                                            React.createElement("span", { className: isActive ? 'marketDetailsTextDecoration' : "", onClick: isActive ? function () { var _a; return DownLoadPDF_1((_a = item_1.AdvisoryDocGuid) === null || _a === void 0 ? void 0 : _a.value); } : undefined }, itemValue.value ? "Yes" : "None"))
                                    });
                                }
                                else if (keys === "ReinsuranceInsuranceIndicator") {
                                    c_three.push({
                                        name: "Reinsurance Indicator",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RestrictedTerritories" && itemValue.value) {
                                    all_c.push({
                                        name: "Restricted Territories",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RestrictedLines" && itemValue.value) {
                                    all_c.push({
                                        name: "Restricted Lines",
                                        value: itemValue.value,
                                    });
                                }
                            }
                        };
                        for (_i = 0, allKeys_1 = allKeys; _i < allKeys_1.length; _i++) {
                            keys = allKeys_1[_i];
                            _loop_1(keys);
                        }
                        //TODO:Condition need to be added - Rajesh
                        // item["AdvisoryFlag"] && item["AdvisoryFlag"]?.applicableToMarketFlag && item["MarketStateGuid"]?.value
                        if ((_c = item_1.Comment) === null || _c === void 0 ? void 0 : _c.applicableToMarketFlag) {
                            all_c.push({
                                name: "Permitted Use",
                                value: "",
                                element: React.createElement("div", null, (_d = item_1.Comment) === null || _d === void 0 ? void 0 : _d.value)
                            });
                        }
                        c_one.push({
                            name: "",
                            value: "",
                            element: React.createElement("span", { onClick: DownloadSubregionsPdf },
                                React.createElement("span", { style: { color: "#007585", cursor: "pointer" } }, "Region / Subregion Definition"),
                                React.createElement("span", null,
                                    React.createElement(FontAwesomeIcon, { style: { marginInline: "15px", fontSize: "18px", color: "#b00303", cursor: "pointer", width: "18px" }, icon: faFilePdf })))
                        });
                        setMarketGuideStatus({ column_one: c_one, column_two: c_two, column_three: c_three, all_column: all_c });
                        setMarketGuideStatusLoader(false);
                    }
                    else {
                        setMarketGuideStatusLoader(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _e.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    setMarketGuideStatusLoader(false);
                    setError(true);
                    console.log("error", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var MarketGuideStatusBody = function () {
        return MarketGuideStatusLoader ?
            React.createElement("div", { style: { display: "flex", alignItems: "center", width: "800px" } },
                React.createElement(UuiSpinner, { style: { marginLeft: "auto" }, variant: "small" })) : !error ?
            React.createElement("div", null,
                React.createElement(UuiFlexlayout, { direction: "row", gap: "lg" },
                    React.createElement("div", { className: "one-third-width" }, MarketGuideStatus.column_one.map(function (data, index) {
                        return React.createElement("div", { key: index, style: { padding: "12px", } },
                            React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                            data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                    })),
                    React.createElement("div", { className: "one-third-width" },
                        " ",
                        MarketGuideStatus.column_two.map(function (data, index) {
                            return React.createElement("div", { key: index, style: { padding: "12px", } },
                                React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                                data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                        })),
                    React.createElement("div", { className: "one-third-width" },
                        " ",
                        MarketGuideStatus.column_three.map(function (data, index) {
                            return React.createElement("div", { key: index, style: { padding: "12px", } },
                                React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                                data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                        }))),
                React.createElement("div", null,
                    " ",
                    MarketGuideStatus.all_column.map(function (data, index) {
                        return React.createElement("div", { key: index, style: { padding: "12px", } },
                            React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                            data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                    })))
            :
                React.createElement("div", null,
                    React.createElement(AonButton, { style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.TEXT, onClick: function () { return fetchMarketGuideStatusData(); } }, "Retry"));
    };
    return (!MarketGuideStatusLoader && ![].length && !MarketGuideStatus.column_one.length) ? null : React.createElement(AonPannel, { headerTitle: "Market Guide Status", Body: React.createElement(MarketGuideStatusBody, null) });
};
var columnHelper = createColumnHelper();
export var columns = function () { return [
    columnHelper.accessor("carrierMarketName", {
        cell: function (info) {
            return (React.createElement("span", null, info.getValue()));
        },
        header: function () { return (React.createElement("div", { className: "sorting" },
            React.createElement("span", null, "Market Name"))); },
    }),
    columnHelper.accessor("carrierInceptionDate", {
        cell: function (info) {
            return (React.createElement("span", null, getDDMMYYYY(info.getValue())));
        },
        header: function () { return (React.createElement("div", { className: "sorting" },
            React.createElement("span", null, "Inception Date"))); },
    }),
    columnHelper.accessor("carrierExpirationDate", {
        cell: function (info) {
            return (React.createElement("span", null, getDDMMYYYY(info.getValue())));
        },
        header: function () { return (React.createElement("div", { className: "sorting" },
            React.createElement("span", null, "Expiration Date"))); },
    }),
    columnHelper.accessor("carrierReinsuranceInsuranceIndicatorName", {
        cell: function (info) {
            return (React.createElement("span", null, info.getValue()));
        },
        header: function () { return (React.createElement("div", { className: "sorting" },
            React.createElement("span", null, "Insurance Indicator"))); },
    }),
]; };
